import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";
import "./index.css";

// import { datadogRum } from "@datadog/browser-rum";
// import { reactPlugin } from "@datadog/browser-rum-react";

// datadogRum.init({
//   applicationId: "b93a3d24-052a-4674-8b07-65523af39a7b",
//   clientToken: "pubdb1760812cb366e412d65f9b2fa2a3b0",
//   site: "us5.datadoghq.com",
//   service: "ac-system",
//   env: "local", // البيئة (production, staging, etc.)
//   version: "1.0.0",
//   sessionSampleRate: 100,
//   sessionReplaySampleRate: 20,
//   trackResources: true,
//   trackUserInteractions: true,
//   trackLongTasks: true,
//   plugins: [reactPlugin({ router: false })],
// });

// datadogRum.startSessionReplayRecording(); 

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
